var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNonContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.034 5.75c-2.018 0-3.666 1.592-3.666 3.57 0 1.979 1.648 3.571 3.666 3.571S8.7 11.3 8.7 9.321c0-1.979-1.648-3.571-3.666-3.571zm13.932 0c-2.018 0-3.666 1.592-3.666 3.57 0 1.979 1.648 3.571 3.666 3.571s3.666-1.592 3.666-3.57c0-1.979-1.648-3.571-3.666-3.571zM5.034 14.046C2.26 14.046 0 16.234 0 18.947v.245H10.068v-.245c0-2.713-2.26-4.9-5.034-4.9zm13.932 0c-2.774 0-5.034 2.188-5.034 4.901v.245H24v-.245c0-2.713-2.26-4.9-5.034-4.9zM10 13.253l.762.762L12 12.778l1.238 1.237.763-.763-1.237-1.237L14 10.778l-.763-.763L12 11.252l-1.237-1.237-.763.763 1.237 1.237L10 13.252z",
    fill: "#2D8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNonContact);
export default __webpack_public_path__ + "static/media/user_Non-contact.aee76244217f66797bade72b16b9854e.svg";
export { ForwardRef as ReactComponent };